var map = {
	"./MBudget.svg": 1246,
	"./Mtel.svg": 1164,
	"./Quickline.svg": 1157,
	"./Salt.svg": 1154,
	"./Spusu.svg": 1165,
	"./Swisscom.svg": 1152,
	"./TalkTalk.svg": 1158,
	"./Wingo.svg": 1153,
	"./migros.svg": 1156,
	"./yallo.svg": 1155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1245;